"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/es.string.sub");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AUTH_REFERRER_KEY = void 0;

require("regenerator-runtime/runtime");

require("./polyfill");

var _oktaAuthJs = _interopRequireDefault(require("@okta/okta-auth-js"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _SCSessionService = _interopRequireDefault(require("./services/SCSessionService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AUTH_REFERRER_KEY = 'oktaAuthLoginReferrer';
exports.AUTH_REFERRER_KEY = AUTH_REFERRER_KEY;

var _cookies = new _universalCookie.default();

var Auth = /*#__PURE__*/function () {
  /**
   * This is populated by AuthProvider
   * @type {null|Auth}
   */

  /**
   * Set when populated
   * @type {Boolean}
   */
  function Auth(config) {
    var _this = this;

    _classCallCheck(this, Auth);

    _defineProperty(this, "_addTokenToManager", function (token) {
      if ('tokens' in token && token.tokens.idToken) {
        _this._idToken = token.tokens.idToken;

        _this._okta.tokenManager.add('idToken', token.tokens.idToken);
      }

      if ('tokens' in token && token.tokens.accessToken) {
        _this._accessToken = token.tokens.accessToken;

        _this._okta.tokenManager.add('accessToken', token.tokens.accessToken);
      }
    });

    this._okta = new _oktaAuthJs.default({
      url: config.url || config.issuer.split('/oauth2/')[0],
      clientId: config.clientId,
      issuer: config.issuer,
      redirectUri: config.redirectUri,
      pkce: false
    });
    this._config = config; // Store tokens in Auth instance because authBearer needs synchronous return of data

    this._idToken = null;
    this._accessToken = null; // Populate tokens, this is async operation

    this._asyncInstance = this._resolveInstance(); // Set up event on token manager to update tokens on renew
    // TODO: Investigate in what scenario the token will change

    this._okta.tokenManager.on('renewed', function (key, newToken) {
      if (key === 'idToken') {
        _this._idToken = newToken;
      }

      if (key === 'accessToken') {
        _this._accessToken = newToken;
      }
    });

    if (process.env.NODE_ENV === 'production') {
      if (typeof window !== 'undefined' && (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && typeof console.log === 'function') {
        console.log('%cWARNING!', 'color:white; background:red; font-size: 16pt');
        console.log('%cThis is a browser feature intended for developers. Using this console may allow attackers to impersonate you and steal your information. Do not enter or paste code that you do not understand.', 'font-size: 14pt'); // eslint-disable-line no-console
      }
    }
  }

  _createClass(Auth, [{
    key: "getInstance",
    value: function () {
      var _getInstance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._asyncInstance);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInstance() {
        return _getInstance.apply(this, arguments);
      }

      return getInstance;
    }()
  }, {
    key: "_resolveInstance",
    value: function () {
      var _resolveInstance2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$Promise$all, _yield$Promise$all2, idToken, accessToken;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all([this.getFromTokenManager('idToken'), this.getFromTokenManager('accessToken')]);

              case 2:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                idToken = _yield$Promise$all2[0];
                accessToken = _yield$Promise$all2[1];
                this._idToken = idToken;
                this._accessToken = accessToken;
                Auth.isResolved = true;
                return _context2.abrupt("return", this);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _resolveInstance() {
        return _resolveInstance2.apply(this, arguments);
      }

      return _resolveInstance;
    }()
  }, {
    key: "forceIsAuthenticated",

    /**
     * Similar to 'isAuthenticated' but this checks the token manager instead of current instance
     * Created for use in SecureRoute to prevent it rendering before tokens in current instance
     * has been loaded
     * @returns {boolean}
     */
    value: function () {
      var _forceIsAuthenticated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var accessToken, idToken;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(process.env.TEST === 'true' && window.localStorage.getItem('okta-token-storage-test'))) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", true);

              case 4:
                _context3.next = 6;
                return this.forceGetAccessToken();

              case 6:
                accessToken = _context3.sent;
                _context3.next = 9;
                return this.forceGetIdToken();

              case 9:
                idToken = _context3.sent;
                return _context3.abrupt("return", !!accessToken && !!idToken);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function forceIsAuthenticated() {
        return _forceIsAuthenticated.apply(this, arguments);
      }

      return forceIsAuthenticated;
    }()
    /**
     * Test if the user has a current active session
     * @returns {Promise<boolean>}
     */

  }, {
    key: "hasActiveSession",
    value: function () {
      var _hasActiveSession = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._okta.session.exists();

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function hasActiveSession() {
        return _hasActiveSession.apply(this, arguments);
      }

      return hasActiveSession;
    }()
  }, {
    key: "extendSession",
    value: function () {
      var _extendSession = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._okta.session.refresh();

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function extendSession() {
        return _extendSession.apply(this, arguments);
      }

      return extendSession;
    }()
  }, {
    key: "_getNonceCookie",
    value: function _getNonceCookie() {
      var nonceCookie = _cookies.get('SCiCareNonceCookie');

      if (nonceCookie) {
        return nonceCookie;
      } //default random (this will force an error in the backend, for nonce validation)


      return '93cPatReeeRuCes';
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(username, password) {
        var referrer,
            transaction,
            responseType,
            scopes,
            response,
            tokens,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                referrer = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : '/';

                if (localStorage) {
                  // Save url to redirect to after a successful login
                  localStorage.setItem(AUTH_REFERRER_KEY, referrer);
                }

                _context6.next = 4;
                return this._okta.signIn({
                  username: username,
                  password: password,
                  sendFingerprint: false
                });

              case 4:
                transaction = _context6.sent;

                if (!(transaction.status === 'SUCCESS')) {
                  _context6.next = 32;
                  break;
                }

                responseType = this._config.responseType || ['id_token', 'token'];
                scopes = this._config.scope || ['openid', 'email', 'profile'];
                _context6.prev = 8;
                _context6.next = 11;
                return this._okta.token.getWithoutPrompt(_objectSpread({
                  responseType: responseType,
                  scopes: scopes,
                  nonce: this._getNonceCookie(),
                  sessionToken: transaction.sessionToken
                }, this._config));

              case 11:
                response = _context6.sent;
                _context6.next = 17;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](8);
                throw new Error('Auth token failed');

              case 17:
                tokens = Array.isArray(response) ? response : [response];
                tokens.forEach(this._addTokenToManager);

                if (!(process.env.NODE_ENV === 'production')) {
                  _context6.next = 29;
                  break;
                }

                _context6.prev = 20;

                if (!this._idToken) {
                  _context6.next = 24;
                  break;
                }

                _context6.next = 24;
                return _SCSessionService.default.setSession(this._idToken.value);

              case 24:
                _context6.next = 29;
                break;

              case 26:
                _context6.prev = 26;
                _context6.t1 = _context6["catch"](20);
                console.error(_context6.t1);

              case 29:
                this.redirect(referrer);
                _context6.next = 37;
                break;

              case 32:
                if (!(transaction.status === 'LOCKED_OUT' || transaction.status === 'PASSWORD_EXPIRED')) {
                  _context6.next = 36;
                  break;
                }

                throw transaction.data;

              case 36:
                throw new Error("Cannot handle login status '".concat(transaction.status, "'"));

              case 37:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[8, 14], [20, 26]]);
      }));

      function login(_x, _x2) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var accessToken, idToken, claims, userInfo;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getFromTokenManager('accessToken');

              case 2:
                accessToken = _context7.sent;
                _context7.next = 5;
                return this.getFromTokenManager('idToken');

              case 5:
                idToken = _context7.sent;

                if (!(accessToken && idToken)) {
                  _context7.next = 17;
                  break;
                }

                if (!this._config.isIFNSW) {
                  _context7.next = 12;
                  break;
                }

                claims = idToken.claims;
                return _context7.abrupt("return", {
                  firstName: claims.name,
                  lastName: claims.family_name,
                  emailVerified: claims.email_verified,
                  email: claims.email,
                  crmContactId: claims.icare_crmcontactid,
                  siContactId: claims.siContactId || '',
                  siAgencyId: claims.siAgencyId || '',
                  oktaId: claims.sub || '',
                  groups: claims.groups
                });

              case 12:
                _context7.next = 14;
                return this._okta.token.getUserInfo(accessToken);

              case 14:
                userInfo = _context7.sent;

                if (!(userInfo.sub === idToken.claims.sub)) {
                  _context7.next = 17;
                  break;
                }

                return _context7.abrupt("return", {
                  firstName: userInfo.given_name,
                  lastName: userInfo.family_name,
                  emailVerified: userInfo.email_verified,
                  email: userInfo.email,
                  crmContactId: userInfo.icare_crmcontactid,
                  groups: userInfo.groups
                });

              case 17:
                return _context7.abrupt("return", undefined);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getUser() {
        return _getUser.apply(this, arguments);
      }

      return getUser;
    }()
  }, {
    key: "getUserGroups",
    value: function () {
      var _getUserGroups = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var token;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getFromTokenManager('idToken');

              case 2:
                token = _context8.sent;

                if (!(!token || !token.claims || !token.claims.groups)) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", []);

              case 5:
                return _context8.abrupt("return", token.claims.groups);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getUserGroups() {
        return _getUserGroups.apply(this, arguments);
      }

      return getUserGroups;
    }()
  }, {
    key: "getUserEmail",
    value: function () {
      var _getUserEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var token;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getFromTokenManager('idToken');

              case 2:
                token = _context9.sent;

                if (!(!token || !token.claims || !token.claims.email)) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", undefined);

              case 5:
                return _context9.abrupt("return", token.claims.email);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getUserEmail() {
        return _getUserEmail.apply(this, arguments);
      }

      return getUserEmail;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var disableSpaCall,
            token,
            _args10 = arguments;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                disableSpaCall = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : false;
                _context10.prev = 1;

                if (!(process.env.NODE_ENV === 'production' && disableSpaCall)) {
                  _context10.next = 6;
                  break;
                }

                token = this.getIdToken();
                _context10.next = 6;
                return _SCSessionService.default.endSession(token);

              case 6:
                this._okta.tokenManager.clear();

                _context10.next = 9;
                return this._okta.signOut();

              case 9:
                _context10.next = 14;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10["catch"](1);
                console.log(_context10.t0);

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[1, 11]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "forgotPassword",
    value: function () {
      var _forgotPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(username) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._okta.forgotPassword({
                  username: username,
                  factorType: 'EMAIL'
                });

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function forgotPassword(_x3) {
        return _forgotPassword.apply(this, arguments);
      }

      return forgotPassword;
    }()
  }, {
    key: "handleAuthentication",
    value: function () {
      var _handleAuthentication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(history) {
        var responseType, scopes, response, tokens;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                responseType = this._config.responseType || ['id_token', 'token'];
                scopes = this._config.scope || ['openid', 'email', 'profile'];
                _context12.next = 4;
                return this._okta.token.getWithoutPrompt(_objectSpread({
                  responseType: responseType,
                  scopes: scopes
                }, this._config));

              case 4:
                response = _context12.sent;
                tokens = Array.isArray(response) ? response : [response];
                tokens.forEach(this._addTokenToManager); // THIS IS ONLY REQUIRED FOR SITECORE TO ALSO GET THE TOKEN

                if (process.env.NODE_ENV === 'production') {
                  // redirect to sitecore
                  this._okta.token.getWithRedirect(_objectSpread({
                    responseType: responseType,
                    scopes: scopes,
                    responseMode: 'form_post'
                  }, this._config));
                } else {
                  this.redirect(history);
                }

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function handleAuthentication(_x4) {
        return _handleAuthentication.apply(this, arguments);
      }

      return handleAuthentication;
    }()
  }, {
    key: "handleImplicitAuthentication",
    value: function () {
      var _handleImplicitAuthentication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this.isAuthenticated) {
                  _context13.next = 5;
                  break;
                }

                _context13.next = 3;
                return this._okta.token.parseFromUrl({
                  url: window.location.href
                });

              case 3:
                response = _context13.sent;

                this._addTokenToManager({
                  tokens: response.tokens
                });

              case 5:
                this.redirect();

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function handleImplicitAuthentication() {
        return _handleImplicitAuthentication.apply(this, arguments);
      }

      return handleImplicitAuthentication;
    }()
  }, {
    key: "getAuthRequestToken",
    value: function getAuthRequestToken() {
      console.warn('WARNING: Using deprecated API. Please update for getAccessToken()');
      return this.getAccessToken();
    }
  }, {
    key: "getFromTokenManager",
    value: function () {
      var _getFromTokenManager = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(tokenId) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(process.env.TEST === 'true' && window.localStorage.getItem('okta-token-storage-test'))) {
                  _context14.next = 4;
                  break;
                }

                return _context14.abrupt("return", JSON.parse(window.localStorage.getItem('okta-token-storage-test'))[tokenId]);

              case 4:
                _context14.next = 6;
                return this._okta.tokenManager.get(tokenId);

              case 6:
                return _context14.abrupt("return", _context14.sent);

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getFromTokenManager(_x5) {
        return _getFromTokenManager.apply(this, arguments);
      }

      return getFromTokenManager;
    }()
  }, {
    key: "getIdToken",
    value: function getIdToken() {
      return this.verifyIdToken(this._idToken);
    }
  }, {
    key: "forceGetIdToken",
    value: function () {
      var _forceGetIdToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var idToken;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.getFromTokenManager('idToken');

              case 2:
                idToken = _context15.sent;
                return _context15.abrupt("return", this.verifyIdToken(idToken));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function forceGetIdToken() {
        return _forceGetIdToken.apply(this, arguments);
      }

      return forceGetIdToken;
    }()
  }, {
    key: "verifyIdToken",
    value: function verifyIdToken(idToken) {
      // Handle expired tokens
      if (idToken && idToken.expiresAt) {
        if (idToken.expiresAt < Math.floor(Date.now() / 1000)) {
          this._okta.tokenManager.clear();

          return undefined;
        }

        return idToken.idToken;
      }

      return undefined;
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var accessToken = this._accessToken;
      return accessToken ? accessToken.accessToken : undefined;
    }
  }, {
    key: "forceGetAccessToken",
    value: function () {
      var _forceGetAccessToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var accessToken;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.getFromTokenManager('accessToken');

              case 2:
                accessToken = _context16.sent;
                return _context16.abrupt("return", accessToken ? accessToken.accessToken : undefined);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function forceGetAccessToken() {
        return _forceGetAccessToken.apply(this, arguments);
      }

      return forceGetAccessToken;
    }()
  }, {
    key: "createTokenFromJWT",
    value: function createTokenFromJWT(JWT) {
      var decodedToken = this.decodeJWT(JWT);
      var payload = decodedToken.payload;
      var scopes = ['openid', 'email', 'profile'];
      var authorizeUrl = "".concat(this._config.issuer, "/v1/authorize");

      this._addTokenToManager({
        token: {
          tokens: {
            accessToken: {
              accessToken: JWT,
              expiresAt: payload.exp,
              tokenType: 'Bearer',
              scopes: scopes,
              authorizeUrl: authorizeUrl,
              userinfoUrl: "".concat(this._config.issuer, "/v1/userinfo")
            },
            idToken: {
              idToken: JWT,
              claims: payload,
              expiresAt: payload.exp,
              scopes: scopes,
              authorizeUrl: authorizeUrl,
              issuer: this._config.issuer,
              clientId: payload.aud
            }
          }
        }
      });
    }
  }, {
    key: "decodeJWT",
    value: function decodeJWT(JWT) {
      return JWT ? this._okta.token.decode(JWT) : '';
    }
    /*
     * Redirects back to the app after a successful authentication
     */

  }, {
    key: "redirect",
    value: function redirect() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
      var history = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (history) {
        history.push(redirectUrl);
      } else {
        window.location = redirectUrl;
      }
    }
  }, {
    key: "clearLocalSession",
    value: function clearLocalSession() {
      this._okta.tokenManager.clear(); // Remove cookies that are defined in the app config


      var sessionCookies = this._config.sessionCookies;

      if (sessionCookies) {
        sessionCookies.map(function (cookie) {
          _cookies.remove(cookie);
        });
      }
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
    /**
     * True if there is a current valid accessToken and idToken in current Auth instance
     * @returns {boolean}
     */

  }, {
    key: "isAuthenticated",
    get: function get() {
      if (process.env.TEST === 'true' && window.localStorage.getItem('okta-token-storage-test')) {
        return true;
      } else {
        var accessToken = this.getAccessToken();
        var idToken = this.getIdToken();
        return !!accessToken && !!idToken;
      }
    }
  }]);

  return Auth;
}();

exports.default = Auth;

_defineProperty(Auth, "sharedInstance", null);

_defineProperty(Auth, "isResolved", false);
//# sourceMappingURL=Auth.js.map